// RealEstate.js
import React, { useState, useContext } from "react";
import "./Realestate.css";                // copy .css -> RealEstate.css and adjust if needed
import { ChatContext } from "../ChatContext";
import { useStrings } from '../strings/StringsContext';

const prompts = [
  { title: "Top hot listings this week", content: "Show high-interest residential and commercial listings trending this week." },
  { title: "Leads to follow up today", content: "Prioritized list of buyer/renter leads due for follow-up with last activity." },
  { title: "Properties with price drop", content: "Recent price reductions by locality, BHK/type, and % change." },
  { title: "Site visits to schedule", content: "Prospects ready for site visits based on engagement and budget fit." },
  { title: "Inventory at risk", content: "Units nearing aging thresholds; recommend offers to increase absorption." },
  { title: "Mortgage/loan insights", content: "Latest mortgage rate snapshot and impact on lead conversion probability." },
];

const imageCycle = ["/Realestate1.jpg", "/Realestate2.jpg", "/Realestate3.jpg"];

const RealEstate = () => {
  const { setTriggeredPrompt, addMessage, setChatState } = useContext(ChatContext);
  const [searchText, setSearchText] = useState("");
const { strings, agentName } = useStrings(); 
  const cardsToShow = prompts.map((prompt, idx) => ({
    ...prompt,
    image: imageCycle[idx % imageCycle.length],
  }));

  // Send text to chatbot & expand
  const sendSearchToChatbot = (text) => {
    if (!text.trim()) return;

    setTriggeredPrompt(text);
    addMessage({
      type: "user",
      text,
      timestamp: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    });

    // Open chatbot in expanded mode
    setChatState((prev) => ({ ...prev, isOpen: true, isExpanded: true }));

    setSearchText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // prevent form submit / page refresh
      sendSearchToChatbot(searchText);
    }
  };

  return (
    <div className="realestate-dashboard">
      <div className="header-section">
        <h1>Good morning! Explore your Real Estate insights</h1>
        <img src="/agentforce-flying.png" alt="Agentforce Flying" className="agentforce-flying" />

        {/* Search bar */}
        <div className="search-bar">
          <img src="/bot-avatar.png" alt="Agentforce Icon" />
          <input
            type="text"
            placeholder="Ask SakCare Agent anything about listings, leads, visits…"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <button
            className="search-send-button"
            onClick={() => sendSearchToChatbot(searchText)}
          >
            <span className="arrow-icon">➤</span>
          </button>
        </div>

        {/* Prompt buttons */}
        <div className="prompt-buttons">
          {prompts.map((prompt, index) => (
            <button
              key={index}
              className="prompt-button"
              onClick={() => sendSearchToChatbot(prompt.title)}
            >
              {prompt.title}
            </button>
          ))}
        </div>
      </div>

      {/* Announcements / Cards */}
      <div className="announcement-section">
        <h2>Real Estate Highlights</h2>
        <div className="announcement-grid">
          {cardsToShow.slice(0, 6).map((card, index) => (
            <div className="announcement-card" key={index}>
              <img className="card-top-image" src={card.image} alt={card.title} />
              <div className="card-content">
                <div className="date">July 28, 2025</div>
                <div className="title">{card.title}</div>
                <div className="description">{card.content}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RealEstate;
